import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import { useAribFinance } from "@/common/Contexts/AribFinanceContext";
import PreCheckoutFormRenderer from "@/pages/checkout/pre-checkout/PreCheckoutFormRenderer";
var PreCheckoutMainForm = function PreCheckoutMainForm() {
  var _useAribFinance$actio = useAribFinance().actions,
    action__clearLocalStorageData = _useAribFinance$actio.action__clearLocalStorageData,
    action__clearDataAfterSubmit = _useAribFinance$actio.action__clearDataAfterSubmit;
  useEffect(function () {
    action__clearLocalStorageData();
    action__clearDataAfterSubmit();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PreCheckoutFormRenderer, null));
};
export default PreCheckoutMainForm;